import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';
import PureRenderComponent from '../PureRenderComponent';
import PropTypes from 'prop-types';

class AddressLineOne extends PureRenderComponent {

    static propTypes = {
        ..._.pick(ValidatedFormField.propTypes, [
            'id',
            'form',
            'onChange',
            'required',
            'disabled',
            'visited',
            'validation',
            'field'
        ]),
        hasLabels: PropTypes.bool,
    };

    static defaultProps = {
        'field': 'addressLine1',
        'id': 'addressline1'
    };

    renderLabel() {
        if (this.props.hasLabels) {
            return (
                <label htmlFor={this.props.id} className="label">
                    {t(`customerdetails.${this.props.id}`)}
                </label>
            );
        }
        return null;
    }

    render () {
        return (
            <div className={ this.props.id }>
                {this.renderLabel()}
                <ValidatedFormField { ...this.props }
                    type="text"
                    name={ this.props.id }
                    id={ this.props.id }
                    field={ this.props.field }
                    label={ t(`customerdetails.${this.props.id}`) }
                    placeholder={ this.props.hasLabels ? '' : t(`customerdetails.${this.props.id}`) }
                    labelClassName="sr-only"
                />
            </div>
        );
    }

}

export default AddressLineOne;



// WEBPACK FOOTER //
// ./src/components/payment/AddressLineOne.js